import { useEffect, useState } from "react";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import deployments from "shared/lib/constants/v1Deployments.json";
import { isDevelopment } from "shared/lib/utils/env";
import { MerkleDistributorFactory } from "shared/lib/codegen/MerkleDistributorFactory";
export var getMerkleDistributor = function (ethereumProvider) {
    if (ethereumProvider) {
        var provider = ethereumProvider.getSigner();
        return MerkleDistributorFactory.connect(isDevelopment()
            ? deployments.kovan.MerkleDistributor
            : deployments.mainnet.MerkleDistributor, provider);
    }
    return undefined;
};
var useMerkleDistributor = function () {
    var _a = useWeb3Wallet(), ethereumProvider = _a.ethereumProvider, active = _a.active;
    var _b = useState(), contract = _b[0], setContract = _b[1];
    useEffect(function () {
        setContract(getMerkleDistributor(ethereumProvider));
    }, [ethereumProvider, active]);
    return contract;
};
export default useMerkleDistributor;
//# sourceMappingURL=useMerkleDistributor.js.map